export const contact = {
    TECHNICAL_SERVICE: {
        value: '+1 (450) 641-8222',
    },
    PHONE: {
        value: '+1 (450) 641-8222',
        secondValue: '+1 (866) 835 8324',
    },
    ADDRESS: {
        value: '687 Rue Giffard, Longueuil, QC J4G 1Y3',
    },
    EMAIL: {
        value: 'info@indotech.ca',
    },
};
